import Header from "./Header";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";
import ExitIntent from "../ExitIntent";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-bone">
      <Header />
      <main className="flex-1 pb-24 lg:pb-0">{children}</main>
      <Footer />
      <StickyMobileCTA />
      <ExitIntent />
    </div>
  );
}
